export const BLOG_POSTS = [
  {
    id: 1,
    title: 'Top 10 Tech Trends to Watch in 2026',
    excerpt: 'From decentralized AI to sustainable hardware, explore the technologies that will define the upcoming year.',
    content: `
      <p>As we approach 2026, the technological landscape is shifting from rapid innovation to profound integration. The focus has moved from just creating new tools to making them work together in harmony with human values and sustainability goals.</p>
      
      <h3>1. Decentralized AI</h3>
      <p>Moving away from massive centralized servers, AI is becoming more distributed. This ensures better privacy, lower latency, and more robust systems that aren't dependent on a single point of failure.</p>
      
      <h3>2. Sustainable Hardware</h3>
      <p>With environmental concerns at an all-time high, tech companies are prioritizing recyclable materials and energy-efficient processing units. The goal is carbon-neutral computing by 2030.</p>
      
      <h3>3. Quantum Computing Milestones</h3>
      <p>While still in its early stages, quantum computing is starting to solve real-world optimization problems in logistics and pharmaceutical research that were previously impossible.</p>
      
      <p>The next year promises to be a pivotal moment for digital transformation, where technology becomes even more indistinguishable from the background of our daily lives.</p>
    `,
    date: 'Feb 15, 2026',
    author: 'Admin',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80',
    category: 'Innovation',
  },
  {
    id: 2,
    title: 'Why Custom EPR Software is Essential for Growth',
    excerpt: 'Discover how tailored digital solutions can streamline your operations and provide a competitive edge.',
    content: `
      <p>In a world of off-the-shelf solutions, the businesses that truly excel are those that build tools tailored specifically to their unique processes. Custom EPR software isn't just a luxury; it's a strategic investment.</p>
      
      <h3>Scalability and Flexibility</h3>
      <p>Generic platforms often reach a ceiling. Custom software grows with you, allowing you to add features and integrations exactly when you need them without fighting against a vendor's roadmap.</p>
      
      <h3>Competitive Differentiation</h3>
      <p>If you use the same tools as your competitors, you're limited by the same constraints. Custom EPR software allows you to automate unique workflows that give you a speed or quality advantage.</p>
      
      <p>At Mini App Tech, we believe that software should fit your business, not the other way around. Our collaborative approach ensures that the solutions we build solve your most pressing headaches.</p>
    `,
    date: 'Feb 10, 2026',
    author: 'Sarah Johnson',
    image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&q=80',
    category: 'Development',
  },
  {
    id: 3,
    title: 'The Future of Mobile User Experience',
    excerpt: 'How micro-interactions and personalized AI interfaces are changing the way we interact with our devices.',
    content: `
      <p>Mobile phones are no longer just tools; they are extensions of our digital selves. The next frontier in mobile UX is predictive, personalized, and invisible.</p>
      
      <h3>Predictive Interfaces</h3>
      <p>Imagine an app that knows what you want before you tap. By analyzing context, location, and time, future apps will present the most relevant information proactively, reducing "app fatigue."</p>
      
      <h3>Emotional Design</h3>
      <p>Through subtle haptics and micro-animations, apps are starting to communicate on an emotional level, providing comfort and clarity during complex tasks.</p>
      
      <p>As designers, our challenge is to balance complexity with simplicity. The most successful mobile apps of 2026 will be those that provide immense value while requiring the least amount of conscious attention.</p>
    `,
    date: 'Feb 05, 2026',
    author: 'Michael Chen',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80',
    category: 'Design',
  },
];
